import index from "./assetListChooser.vue";
export default index;
